import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

import { Flex, Indicator, Popover, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { TEST_BUILD } from '@/constant/api.ts';

import { Navbar } from '@/entities/Navbar';
import { UserCard } from '@/entities/User';

import { UserProfile } from '../UserProfile';

import classes from './Header.module.css';

export const Header = () => {
	const Card = forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<'div'>>((props, ref) => (
		<div ref={ref} {...props}>
			<UserCard />
		</div>
	));

	return (
		<Flex classNames={classes}>
			<Flex className={classes.logo}>
				<Link to={'/'}>
					{TEST_BUILD ? (
						<Indicator inline label="Test" size={16} color={'red'}>
							<Text size="xl" fw={800} c="var(--mantine-primary-color-0)">
								Бронирование
							</Text>
						</Indicator>
					) : (
						<Text size="xl" fw={800} c="var(--mantine-primary-color-0)">
							Бронирование
						</Text>
					)}
				</Link>
			</Flex>
			<Flex className={classes.right} justify="space-between" w={'100%'}>
				<Navbar />

				<Popover position="top" offset={-62} shadow="md" zIndex={100}>
					<Popover.Target>
						<Card />
					</Popover.Target>
					<Popover.Dropdown>
						<UserProfile />
					</Popover.Dropdown>
				</Popover>
			</Flex>
		</Flex>
	);
};
